export const PACKAGE_SUBMIT_MODELING_STOCK_MESSAGE = "该套餐订单的配件库存不足，请联系客服";
export const SUBMIT_MODELING_MODEL_FILE_MESSAGE_KEY = "submit_modeling_model_file_not_ready";
export const SUBMIT_MODELING_MODEL_FILE_MESSAGE =
	"模型文件暂未准备完成，请稍后重试或联系客服处理";

const INVENTORY_ERROR_PATTERNS = [
	"套餐配件库存不足",
	"不存在库存记录",
	"库存记录不存在",
	"可用库存不足"
];

const PACKAGE_OUTBOUND_CONTEXT_PATTERNS = ["创建套餐出库申请失败", "无法创建出库单", "套餐订单"];

const MODEL_FILE_ERROR_PATTERNS = [
	"auto模型文件不存在",
	"print模型文件不存在",
	"不能复制到print目录",
	"不能推送构建打印文件队列"
];

const INTERNAL_PATH_PATTERNS = [
	/objs\/(?:auto|print|download)\//,
	/runtime\/model\//,
	/(?:^|[\s:])\/Users\//,
	/(?:^|[\s:])[A-Za-z]:\\/,
	/shop\.api\.suwa3d\.com/
];

export function isPackageSubmitModelingStockError(message = "") {
	const text = String(message || "").trim();
	if (!text) {
		return false;
	}

	if (text.includes("套餐配件库存不足")) {
		return true;
	}

	const hasInventoryError = INVENTORY_ERROR_PATTERNS.some((pattern) => text.includes(pattern));
	if (!hasInventoryError) {
		return false;
	}

	return PACKAGE_OUTBOUND_CONTEXT_PATTERNS.some((pattern) => text.includes(pattern));
}

export function isSubmitModelingModelFileError(message = "") {
	const text = String(message || "").trim();
	if (!text) {
		return false;
	}

	const hasModelFileError = MODEL_FILE_ERROR_PATTERNS.some((pattern) =>
		text.includes(pattern)
	);
	if (hasModelFileError) {
		return true;
	}

	const hasInternalPath = INTERNAL_PATH_PATTERNS.some((pattern) => pattern.test(text));
	return text.includes("模型文件不存在") && hasInternalPath;
}

export function normalizeSubmitModelingErrorMessage(message = "") {
	const text = String(message || "").trim();
	if (!text) {
		return "";
	}

	if (isSubmitModelingModelFileError(text)) {
		return SUBMIT_MODELING_MODEL_FILE_MESSAGE;
	}

	if (isPackageSubmitModelingStockError(text)) {
		return PACKAGE_SUBMIT_MODELING_STOCK_MESSAGE;
	}

	return text;
}

export function getSubmitModelingErrorMessage(errorLike, fallback = "") {
	const rawMessage =
		errorLike?.message?.$t ||
		errorLike?.message ||
		errorLike?.$t ||
		errorLike?.msg ||
		fallback;

	return normalizeSubmitModelingErrorMessage(rawMessage || fallback || "");
}
